import { render } from "./AloneTextOnImage.vue?vue&type=template&id=279cc7a5&scoped=true"
import script from "./AloneTextOnImage.vue?vue&type=script&lang=js"
export * from "./AloneTextOnImage.vue?vue&type=script&lang=js"

import "./AloneTextOnImage.vue?vue&type=style&index=0&id=279cc7a5&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279cc7a5"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/AloneTextOnImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "279cc7a5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('279cc7a5', __exports__)) {
    api.reload('279cc7a5', __exports__)
  }
  
  module.hot.accept("./AloneTextOnImage.vue?vue&type=template&id=279cc7a5&scoped=true", () => {
    api.rerender('279cc7a5', render)
  })

}


export default __exports__